<template lang="pug">
  .card
    .card-header
      .columns
        .column #[.text-large.text-bold {{ title }}]
        .column.col-auto(v-if="icon") #[i.fa-lg(:class="icon")]
    slot(name="card-body")
    slot(name="card-footer")
</template>

<script>
export default {
  props: {
    title: String,
    icon: String,
  },
}
</script>

<style lang="stylus" scoped>
.card
  height 100%
</style>
